import { Component } from '@angular/core';

@Component({
    selector: 'app-footer-title',
    templateUrl: './footer-title.component.html',
    styleUrls: ['./footer-title.component.scss'],
    standalone: false,
})
export class FooterTitleComponent {
    constructor() {}
}
